import { Controller } from '@hotwired/stimulus'

// Keyboard chapter navigation. ArrowLeft → previous chapter, ArrowRight → next
// chapter, using the URLs passed as values (present only when a sibling exists).
// Ignored while the reader is typing in a field or with a modifier held, and
// while a modal dialog (the TOC drawer) is open. Auto-registered by the glob.
export default class extends Controller {
  static values = { prev: String, next: String }

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener('keydown', this.onKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.onKeydown)
  }

  onKeydown(event) {
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return
    if (this.isTyping(event.target)) return
    if (document.querySelector('dialog[open]')) return

    if (event.key === 'ArrowRight' && this.hasNextValue && this.nextValue) {
      event.preventDefault()
      Turbo.visit(this.nextValue)
    } else if (event.key === 'ArrowLeft' && this.hasPrevValue && this.prevValue) {
      event.preventDefault()
      Turbo.visit(this.prevValue)
    }
  }

  isTyping(target) {
    if (!target) return false
    const tag = target.tagName
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable
  }
}
